/* eslint-disable */
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Card, TEAL, TEXT, SUB, LIGHT } from "../components";
import { STRINGS } from "./strings";

const STORAGE_KEY = "8go-ui-lang";

export const LANG_HANT = "zh-Hant";
export const LANG_HANS = "zh-Hans";

const LanguageContext = createContext(null);

function readStoredLang() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s === LANG_HANS || s === LANG_HANT) return s;
  } catch (e) { /* ignore */ }
  return LANG_HANT;
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(readStoredLang);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    try {
      document.documentElement.lang = lang === LANG_HANS ? "zh-Hans" : "zh-Hant";
    } catch (e) { /* ignore */ }
  }, [lang]);

  const t = useCallback(
    (key) => {
      const row = STRINGS[key];
      if (!row) return key;
      if (lang === LANG_HANS) return row.hans != null ? row.hans : row.hant;
      return row.hant;
    },
    [lang]
  );

  const value = useMemo(
    () => ({ lang, setLang, t, LANG_HANT, LANG_HANS }),
    [lang, setLang, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return ctx;
}

export function LanguagePickerCard({ style: cardStyle } = {}) {
  const { lang, setLang, t, LANG_HANT, LANG_HANS } = useLanguage();
  const pill = (active) => ({
    flex: 1,
    textAlign: "center",
    padding: "14px 12px",
    borderRadius: 12,
    cursor: "pointer",
    fontSize: 17,
    fontWeight: 700,
    border: `2px solid ${active ? TEAL : LIGHT}`,
    background: active ? TEAL + "18" : "#fff",
    color: active ? TEAL : SUB,
  });
  return (
    <Card style={cardStyle}>
      <p style={{ color: TEXT, fontWeight: 700, fontSize: 17, margin: "0 0 12px" }}>{t("lang.title")}</p>
      <div style={{ display: "flex", gap: 10 }}>
        <button type="button" onClick={() => setLang(LANG_HANT)} style={pill(lang === LANG_HANT)}>
          {t("lang.hant")}
        </button>
        <button type="button" onClick={() => setLang(LANG_HANS)} style={pill(lang === LANG_HANS)}>
          {t("lang.hans")}
        </button>
      </div>
      <p style={{ color: SUB, fontSize: 14, margin: "12px 0 0", lineHeight: 1.45 }}>{t("lang.hint")}</p>
    </Card>
  );
}
